import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import {
    applySlidingAppearanceToDocument,
    getSlidingAppearanceTokens,
    loadSlidingAppearance,
    saveSlidingAppearance,
    SLIDING_APPEARANCE_DARK,
    SLIDING_APPEARANCE_LIGHT,
} from "./appearance";

const AppearanceContext = createContext(null);

export function AppearanceProvider({ children }) {
    const [mode, setModeState] = useState(() => {
        const loaded = loadSlidingAppearance();
        applySlidingAppearanceToDocument(loaded);
        return loaded;
    });

    const setMode = useCallback((nextMode) => {
        const normalized = saveSlidingAppearance(nextMode);
        setModeState(normalized);
    }, []);

    useEffect(() => {
        applySlidingAppearanceToDocument(mode);
    }, [mode]);

    const value = useMemo(
        () => ({
            mode,
            setMode,
            tokens: getSlidingAppearanceTokens(mode),
            isDark: mode === SLIDING_APPEARANCE_DARK,
        }),
        [mode],
    );

    return <AppearanceContext.Provider value={value}>{children}</AppearanceContext.Provider>;
}

export function useSlidingAppearance() {
    const ctx = useContext(AppearanceContext);
    if (!ctx) {
        return {
            mode: SLIDING_APPEARANCE_LIGHT,
            setMode: () => {},
            tokens: getSlidingAppearanceTokens(SLIDING_APPEARANCE_LIGHT),
            isDark: false,
        };
    }
    return ctx;
}
